"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@shared/constants/widgets");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
/**
 * Handles managing synchronization between the ui pages and the db pages
 */
function PageSyncManagerFactory(activeReport, flowingPages) {
    return {
        /**
         * Note: this only sets the pages in the `containers` database.
         * It will not set widget states in the `widgetStates` database.
         * So it should only be used when it is guaranteed that the widgets
         * in `dbPages` already have valid states in the `widgetStates` database.
         */
        setPages: function (dbPages) {
            return setDbPages(dbPages).then(setUiPages);
        },
        /**
         * Checks if the ui pages are in sync with the db pages.
         * Does so by checking for are any widgets in the ui but not the db (or vice-versa).
         * Ignores page break widgets since they are treated differently by the db and the ui.
         */
        arePagesInSync: function () {
            var uiWidgetIds = getUiWidgetIds();
            var dbWidgetIds = getDbWidgetIds();
            var uniqueWidgetIds = lodash_1.default.xor(uiWidgetIds, dbWidgetIds);
            return uniqueWidgetIds.length === 0;
        }
    };
    function setDbPages(dbPages) {
        return activeReport.setPages(dbPages);
    }
    function setUiPages() {
        return flowingPages.resetPages();
    }
    function getUiWidgetIds() {
        return getWidgetIds(flowingPages.getPages());
    }
    function getDbWidgetIds() {
        return getWidgetIds(activeReport.getPages());
    }
    function getWidgetIds(pages) {
        var widgetIds = [];
        lodash_1.default.forEach(pages, function (page) {
            lodash_1.default.forEach(page.widgets, function (widget) {
                if (widget._type !== widgets_1.PR_WIDGETS.PAGE_BREAK) {
                    // page breaks are saved differently in the ui vs db, so no need to validate those
                    widgetIds.push(widget._id);
                }
            });
        });
        return widgetIds;
    }
}
(function (module) {
    module.factory('pr.pageSyncManager', [
        'prActiveReport',
        'prFlowingPages',
        PageSyncManagerFactory
    ]);
})(angular_1.module('qualtrics.pr'));
